<button (click)="navigateToConfigureData()" class="e-export-button" [disabled]="disableOptions">Configure & Export</button>

<button (click)="navigateToSkuPriceHistory()" class="e-price-history-button" [disabled]="disableOptions">View Price History</button>

<!-- TODO: no sku sets in first release
<div class="e-sku-set-options">
    <button class="e-add-sku-button" disabled>Add to SKU Set</button>
    <button class="e-create-set-button" disabled>Create SKU Set</button>
    <button class="e-remove-skus-button" disabled>Remove SKUs</button>
    <button class="e-view-sets-button" disabled>View all SKU Sets</button>
</div>
-->
